import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-457220ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "oidc-user:", -1))

import { computed } from 'vue';
import { User } from 'oidc-client-ts';
import { helloService } from '@/services/backend/HelloService';
import TokensDetails from '@/components/TokensDetails.vue';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetails',
  props: {
    oidcUser: null
  },
  setup(__props: any) {

const props = __props as { oidcUser: User };



const oidcJson = computed(() => JSON.stringify(props.oidcUser, null, 2));
const expire = computed(() => {
  if (props.oidcUser.expires_at) {
    const exp = new Date(0);
    exp.setUTCSeconds(props.oidcUser.expires_at);
    return `${exp.toLocaleString()}`;
  }
  return '?';
});

async function apiCall() {
  const hello: string = await helloService.hello();
  // eslint-disable-next-line
  alert(`says: ${hello}`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "button",
      value: "API call",
      onClick: apiCall
    }),
    _createElementVNode("p", null, "Sub: " + _toDisplayString(props.oidcUser.profile.sub) + " Exp: " + _toDisplayString(_unref(expire)), 1),
    _hoisted_1,
    _createElementVNode("pre", null, _toDisplayString(_unref(oidcJson)), 1),
    _createVNode(TokensDetails, {
      "id-token": props.oidcUser.id_token,
      "access-token": props.oidcUser.access_token,
      "refresh-token": props.oidcUser.refresh_token
    }, null, 8, ["id-token", "access-token", "refresh-token"])
  ]))
}
}

})